// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"live_search_wrapper__SG0ad","input":"live_search_input__SEz1f","option_wrapper":"live_search_option_wrapper__6NWZ6","option":"live_search_option__PygHa"};